<template lang="html">
    <div v-if="open" :class="['dropdown', this.placement]">
        <div class="dropdown-menu">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            placement: String,
            remainOpenOnButtonClick: Boolean,
            open: {
                default: false,
                type: Boolean
            }
        },
        data() {
            return {
                mountedEvents: false,
                openDropdown: false
            }
        },
        mounted() {
            this.initialiseIfOpen();
        },
        methods: {
            initialiseIfOpen() {
                if (this.open) {
                    this.$root.$emit('dropdown-menu-opened', this);
                }
            },
        },
        
        watch: {
            'open': 'initialiseIfOpen'
        }
    }
</script>